import { NO_OP_MESSAGE__NATIVE } from '../../utils/constants';

export const useBootstrapNotificationConfiguration = () => {
  throw Error(NO_OP_MESSAGE__NATIVE); // optional
};
